<template>
  <div class="col s12 pa-0 pb-1 pt-1" v-if="item">
    <div class="card ma-0 col s12 pa-0 grey lighten-4 card-produto-carrinho">
      <div class="col pa-0 s12">
        <div
          style="line-height: 3rem;"
          class="tooltipped truncate fonte w600 col s12 pa-0 pl-1 pr-1"
          data-position="left"
          :data-tooltip="item.descricao"
        >
          {{ item.sku }}: {{item.descricao}}
        </div>

        <div class="divider col s12 pa-0" />

        <button v-if="temSimilar" class="btn-floating btn-small similar-button tooltipped" data-position="left"
          data-tooltip="Ver itens similares" @click="verSimilares(item)">
          <i class="material-icons">compare_arrows</i>
        </button>

        <div class="valign-wrapper col s12 pa-0">
          <img v-if="item.photo" style="mix-blend-mode: darken;height: auto;width: auto;max-height: 150px;" class="col s12 pa-1 center-block" :src="`data:image/jpeg;base64,${item.photo}`"/>
          <img v-else style="mix-blend-mode: darken;height: auto;width: auto;max-height: 150px; " class="col s12 pa-1 center-block" src="webapi/resource/foto_indisponivel.png" />
        </div>
      </div>
      <div class="divider col s12 pa-0" />
      <div class="col s12 pt-1">
        <b style="line-height: normal;">R$ {{ item.total | grana }}</b>
      </div>
      <div class="col ma-0 pa-0 s12" >
        <div class="col s12 pa-0 valign-wrapper">
          <div class="col s4 pa-0">
            <div class="btn-flat btn-floating" @click="removerQuantidadeItem(item)" v-if="item.quantidade > item.quantidadeMultipla">
              <i
                style="line-height: 1.7;"
                class="tooltipped material-icons black-text right"
                data-position="top"
                data-tooltip="Remover item"
              >remove</i>
            </div>
            <div class="btn-flat btn-floating" @click="removerItem(item)" v-else>
              <i
                style="line-height: 1.7;"
                class="tooltipped material-icons black-text right"
                data-position="top"
                data-tooltip="Remover item"
              >delete</i>
            </div>
          </div>
          <div class="col s4 pa-0">
            <div
              style="height: 64px;padding-top: 22px !important;padding-bottom: 22px !important;"
              v-if="listItemIdSpinner && listItemIdSpinner.find(id => id == item.itemId)"
            >
              <span class="preloader-wrapper small active" style="height: 20px;width: 20px;">
                <div class="spinner-layer" style="border-color: black;">
                  <div class="circle-clipper left"><div class="circle"></div></div>
                  <div class="gap-patch"><div class="circle"></div></div>
                  <div class="circle-clipper right"><div class="circle"></div></div>
                </div>
              </span>
            </div>
            <div v-else class="pa-0"><span>{{item.quantidade}}</span></div>
          </div>
          <div class="col s4 pa-0">
            <div class="btn-flat btn-floating" @click="adicionarItem(item)">
              <i
                style="line-height: 1.7;"
                class="tooltipped material-icons black-text right"
                data-position="top"
                data-tooltip="Adicionar item"
              >add</i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EditarQtd from './EditarQtd.vue';

export default {
  name:'card-produto',
  components: {
    EditarQtd,
  },
  props:{
    item: null,
    ordem: null,
    listItemIdSpinner: null,
    temSimilar: false,
  },
  data () {
    return {
      qtd: 1,
    }
  },
  watch: {
    item: function(nv) {
      if(nv && nv.quantidade) this.qtd = nv.quantidade;
    },
  },
  methods: {
    defineQtd(qtd) {
      this.$emit('defineQtd', qtd);
    },
    removerItem(item) {
      this.$emit('onRemoveItem', item);
    },
    removerQuantidadeItem(item) {
      this.$emit('onRemoverQuantidadeItem', item)
    },
    adicionarItem(item) {
      this.$emit('onAddItem', item);
    },
    verSimilares(item) {
      this.$emit('onVerSimilares', item);
    },
  }
}
</script>

<style scope>
.card-produto-carrinho { position: relative; }
.similar-button { position: absolute; z-index: 2; top: 48px; right: 8px; width: 34px; height: 34px; }
.similar-button i { font-size: 19px; line-height: 34px; }
</style>





// WEBPACK FOOTER //
// CardProduto.vue?ce50726e